@for (position of positions; track position) {
	@if (groupedToasts()[position]?.length) {
		<div
			class="fixed flex flex-col md:px-4 py-2 max-w-full z-toast {{ getPositionClasses(position) }}"
		>
			@for (toast of groupedToasts()[position]; track toast.id) {
				<toast
					[text]="toast.message"
					[type]="toast.type"
					[timer]="toast.duration"
					class="{{ getAnimationClass(toast) }} transition-all max-w-150 w-full"
					[closable]="true"
					(closeNotify)="toastService.dismiss(toast.id)"
					(pauseNotify)="toastService.pause(toast.id)"
					(restartNotify)="toastService.restart(toast.id)"
					data-cy="c-toast"
					[attr.data-cy-2]="'c-toast-' + toast.type"
				/>
			}
		</div>
	}
}
